import { Form } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FormItem from "../UI/FormItem";
import { editEmployeeProfileDetails } from "../../slices/Employee/editEmployeeProfile.slice";
import { showSuccess } from "../../helpers/Notifications/Notification";
import { getLocalStorage, checkIsSuperAdmin } from "../../helpers/utils";
import { EMAIL_REGEX, NON_SPECIAL_CHAR_REGEX } from "../../helpers/constants";

const EditProfileForm = ({ onCancel, handleChangePasswordOnClick, form }) => {
  const { editProfileError } = useSelector(
    (state) => state.editEmployeeProfile
  );
  const dispatch = useDispatch();
  const userData = getLocalStorage("USER_DETAILS");

  const onSubmitSuccess = (values) => {
    const data = {
      name: values.name,
    };
    dispatch(
      editEmployeeProfileDetails(data, () => {
        showSuccess("Profile Edited Successfully");
        onCancel();
      })
    );
  };

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmitSuccess}
        autoComplete="off"
        validateTrigger="onBlur"
        className="edit-profile-form"
      >
        <FormItem
          name="name"
          expand
          rules={[
            {
              required: true,
              message: "Please fill the name to proceed!",
            },
            {
              pattern: NON_SPECIAL_CHAR_REGEX,
              message: "Please enter a valid name!",
            },
          ]}
          placeholderText={"Name"}
          defaultValue={
            userData?.user_name ? userData?.user_name : userData?.name
          }
          formErrors={editProfileError}
        />

        {!checkIsSuperAdmin() && (
          <FormItem
            name="orgName"
            rules={[{}]}
            placeholderText={"Name of Organization"}
            disabled={true}
            defaultValue={userData?.organization}
            formErrors={editProfileError}
          />
        )}
        <FormItem
          name="emailID"
          rules={[
            {
              pattern: EMAIL_REGEX,
              message: `Invalid Email ID`,
            },
          ]}
          placeholderText={"Email ID"}
          disabled={true}
          defaultValue={
            userData?.user_email ? userData?.user_email : userData?.email
          }
          formErrors={editProfileError}
        />
        {!checkIsSuperAdmin() && (
          <FormItem
            name="department"
            rules={[{}]}
            placeholderText={"Name of Department"}
            disabled={true}
            defaultValue={userData?.department}
            formErrors={editProfileError}
          />
        )}
        <div
          onClick={handleChangePasswordOnClick}
          className="change-password-text"
        >
          <p>Change Password?</p>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button className="login-btn cancel" type="button">
            <span className="login-btn-text" onClick={() => onCancel()}>
              CANCEL
            </span>
          </button>

          <button className="login-btn" type="submit">
            <span className="login-btn-text">UPDATE</span>
          </button>
        </div>
      </Form>
    </div>
  );
};

export default EditProfileForm;
